import TableInventory from './TableInventory'

const Inventory = () => {
  return (
      <div className='h-[88vh] overflow-y-scroll p-10 w-full'>
          <TableInventory/>
      </div>
  );
};

export default Inventory;
